import i18n from "../i18n";

const OwnerLogsService = {
    convertDataTypeToValue: function (dataType) {
        return dataType === "board" ? i18n.t("table.owner_logs_table.board_changes") :i18n.t("table.owner_logs_table.owner_changes")
      },
}
export default OwnerLogsService;